export const collaborationSetup = {
  junior: {
    workflows: [
      { name: 'Daily Standups', description: 'Participate in daily team sync meetings', frequency: 'Daily at 9 AM' },
      { name: 'Code Reviews', description: 'Submit PRs for review and review others\' code', process: 'All code must be reviewed before merge' },
      { name: 'Sprint Planning', description: 'Participate in sprint planning sessions', frequency: 'Bi-weekly' }
    ],
    tools: [
      { name: 'Slack', purpose: 'Team communication', channels: ['#backend-team', '#general'] },
      { name: 'Jira', purpose: 'Task tracking', access: 'Developer role' },
      { name: 'GitHub', purpose: 'Code collaboration', permissions: 'Read/Write on team repos' }
    ],
    processes: [
      { name: 'Bug Reporting', steps: ['Reproduce issue', 'Create Jira ticket', 'Assign to team lead'] },
      { name: 'Feature Development', steps: ['Review requirements', 'Create branch', 'Develop', 'Test', 'Submit PR'] }
    ]
  },
  mid: {
    workflows: [
      { name: 'Architecture Reviews', description: 'Participate in system design discussions', frequency: 'Weekly' },
      { name: 'Mentoring', description: 'Mentor junior developers', commitment: '2-3 hours per week' },
      { name: 'Technical Debt Planning', description: 'Identify and plan technical debt resolution', frequency: 'Monthly' }
    ],
    tools: [
      { name: 'Confluence', purpose: 'Documentation', access: 'Editor permissions' },
      { name: 'Datadog', purpose: 'Monitoring and alerting', access: 'Read/Write dashboards' },
      { name: 'PagerDuty', purpose: 'On-call rotation', schedule: 'Rotating weekly shifts' }
    ],
    processes: [
      { name: 'Performance Reviews', steps: ['Analyze metrics', 'Identify bottlenecks', 'Propose solutions', 'Implement fixes'] },
      { name: 'Security Reviews', steps: ['Code security scan', 'Dependency audit', 'Vulnerability assessment'] }
    ]
  },
  senior: {
    workflows: [
      { name: 'Technical Leadership', description: 'Lead technical decisions and architecture', responsibility: 'System design ownership' },
      { name: 'Cross-team Collaboration', description: 'Coordinate with other engineering teams', frequency: 'Weekly sync meetings' },
      { name: 'Incident Response', description: 'Lead incident response and post-mortems', availability: '24/7 on-call rotation' }
    ],
    tools: [
      { name: 'AWS Console', purpose: 'Infrastructure management', access: 'Admin permissions' },
      { name: 'Terraform Cloud', purpose: 'Infrastructure as code', role: 'Team admin' },
      { name: 'Splunk', purpose: 'Log analysis and monitoring', access: 'Full access' }
    ],
    processes: [
      { name: 'Capacity Planning', steps: ['Analyze growth trends', 'Forecast resource needs', 'Plan scaling strategy'] },
      { name: 'Technology Evaluation', steps: ['Research solutions', 'Create POCs', 'Present recommendations', 'Lead adoption'] }
    ]
  }
};
